export default __webpack_public_path__ + "static/1734255922-64913308-1180x285-coaches-collage3-59add7e984a584ceb1edf95401787c85.webp";